
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">           
            <campaign-attached-edit *ngSwitchCase="true"></campaign-attached-edit>
            <campaign-attached-details *ngSwitchCase="false"></campaign-attached-details>
        </div>
    </ng-template>  
</main-form-modal>